// service/Hooks/useFacturationFilters.js
import { useState, useCallback } from 'react';

const useFacturationFilters = (initialFilters = {}) => {
  const [filters, setFilters] = useState({
    accountName: '',
    statut: '',
    trimestre: '',
    annee: '',
    dateDebut: '',
    dateFin: '',
    sortBy: '',
    sortDescending: false,
    pageNumber: 1,
    pageSize: 15,
    ...initialFilters
  });

  const updateFilters = useCallback((newFilters) => {
    setFilters(prev => ({
      ...prev,
      ...newFilters
    }));
  }, []);

  const resetFilters = useCallback(() => {
    setFilters({
      accountName: '',
      statut: '',
      trimestre: '',
      annee: '',
      dateDebut: '',
      dateFin: '',
      sortBy: '',
      sortDescending: false,
      pageNumber: 1,
      pageSize: 15
    });
  }, []);

  const getApiParams = useCallback(() => {
    const params = { ...filters };
    
    // Nettoyer les valeurs vides pour l'API
    Object.keys(params).forEach(key => {
      if (params[key] === '' || params[key] === null || params[key] === undefined) {
        delete params[key];
      }
    });

    return params;
  }, [filters]);

  return {
    filters,
    updateFilters,
    resetFilters,
    getApiParams,
    hasActiveFilters: !!(
      filters.accountName || 
      filters.statut || 
      filters.trimestre || 
      filters.annee || 
      filters.dateDebut || 
      filters.dateFin
    )
  };
};

export default useFacturationFilters;